<template>
	<div class="tabs-form">
		<div class="table">
			<el-table stripe style="width: 100%; min-height: 570px;" :data="tableData">
        <el-table-column prop="user.realname" label="用户" width="120"></el-table-column>
        <el-table-column prop="ip" label="IP地址" width="110"></el-table-column>
        <el-table-column prop="method" label="请求方法" width="80"></el-table-column>
        <el-table-column prop="url" label="请求地址" width="200"></el-table-column>
        <el-table-column prop="status_code" label="响应状态" width="80"></el-table-column>
        <el-table-column prop="request_params" label="请求参数"></el-table-column>
        <el-table-column prop="created_at" label="时间" width="200"></el-table-column>
			</el-table>
			<div class="pagination">
				<div>总计：{{ total }}条/{{ last_page }}页</div>
				<el-pagination
					:current-page.sync="page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="page_size"
					:total="total"
					background
					layout="prev, pager, next, jumper, sizes, slot"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange"
				>
				</el-pagination>
			</div>
		</div>

	</div>
</template>
<script>
export default {
	data() {
		return {
      page: 1,
			page_size: 10,
			last_page: '',
      total: 0,
      tableData: [],
    }
	},
	created() {
    this.searchResult()
	},
	methods: {
    handleCurrentChange(val) {
      this.page = val
      this.searchResult()
    },
    handleSizeChange(val) {
			this.page = 1
      this.page_size = val
      this.searchResult()
    },
    // 列表搜索
    async searchResult() {
			const data = await this.$api.user.httpGet('system-log', {
        page: this.page,
        page_size: this.page_size
      })
			this.tableData = data.data
			this.total = data.meta.total
			this.last_page = data.meta.last_page
    },
  },
}
</script>
<style scoped lang="scss">
.box {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box:hover {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box2 {
	margin-right: 15px;
	background: #f7f8fa;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
/deep/ .el-form-item__content {
  line-height: 0 !important;
}
.form {
	padding: 15px 0px 0px 19px !important;
	display: flex;
	justify-content: space-between;
	min-height: 40px;
	background: #ffffff;
}
.table {
	margin-top: 10px;
	padding: 20px;
	display: block;
	background: #ffffff;
}
.pagination {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-top: 26px;
}
.icon-circle {
	width: 28px;
	height: 28px;
	border-radius: 100%;
	background: #fff8f5;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.width-264 {
	width: 264px;
}
.form-reset {
	display: flex;
	flex-wrap: nowrap;
  /deep/ .el-form-item__content {
    display: flex;
    align-items: center;
  }
}
</style>
